export enum EntriesGroupAndSortKey {
  CustomerOrg = "CUSTOMER_ORG",
  Talent = "TALENT",
  Time = "TIME",
  CustomerCC = "CUSTOMER_CC",
  WorkLocation = "WORK_LOCATION",
}

export const ENTRIES_DEFAULT_GROUPING = [
  EntriesGroupAndSortKey.CustomerOrg,
  EntriesGroupAndSortKey.Talent,
];

export const MIN_GROUPS = 2;
export const MAX_GROUPS = 4;

export const MILLISECONDS_IN_DAY_MINUS_ONE = 86399999;

export const ENTRIES_STATUS_TYPES = ["actualized", "absence"];

export const ENTRIES_APPROVAL_TYPES = [
  "New",
  "Rejected",
  "Approved",
  "CustomerRejected",
];

export const ENTRIES_FILTERS_REJECTED_LOCAL_STORAGE = "entriesFiltersRejected";
export const ENTRIES_FILTERS_ABSENCE_LOCAL_STORAGE = "entriesFiltersAbsence";
export const ENTRIES_FILTERS_CUSTOM_LOCAL_STORAGE = "entriesFiltersCustom";
export const ENTRIES_FILTERS_GROUPING_LOCAL_STORAGE = "entriesFiltersGrouping";

export const WORKTIME_BANK_LEAVE_ABSENCE_TYPE = "WORKTIME_BANK_LEAVE";
export const BANK_HOLIDAY_ABSENCE_TYPE = "BANK_HOLIDAY";

export const TIME_WORK_EXPENSE_CODE = "aikatyo";
export const MONTHLY_SALARY_EXPENSE_CODE = "kuukausipalkka";
